import * as React from 'react';
import * as d3 from 'd3';

export default class SingleResponseChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            alertLevel: props.alertLevel
        }

        this.calculateSVGVals = this.calculateSVGVals.bind(this);
        this.determineFill = this.determineFill.bind(this); 
    }

    componentDidMount() {
        this.calculateSVGVals();
    }

    calculateSVGVals() {
        // any d3 work here
    }
    //  Orange: f56f3f
// Red: e7233d
// Green: 18ee97
// Yellow: feb743
// Purple: 8e0666

    determineFill(alertLevel) {
        if(alertLevel === 1) {
            return "#18ee97";
        }
        else if(alertLevel ===  2) {
            return "#feb743";
        }
        else if(alertLevel === 3){
            return "#f56f3f";
        }
        else if(alertLevel === 4){
          return "#8e0666";
        }
        else if(alertLevel === 5){
            return "#e7233d";
        }
        else {
            return "#000";
        }
    }

    render() {
        return (
          <div className="radial-svg-wrapper">
            <svg
              ref="radialSVG"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 159 159"
            >
              <g>
                <circle
                  ref="level5"
                  cx="79.5"
                  cy="79.5"
                  r="79"
                  fill={
                    this.props.alertLevel === 5 ? "#e7233d" : "#000"
                  }
                  stroke="#e0e0e0"
                />
                <circle
                  ref="level4"
                  cx="79.5"
                  cy="79.5"
                  r="63.2"
                  fill={
                    this.props.alertLevel === 4 ? "#8e0666" : "#000"
                  }
                  stroke="#e0e0e0"
                />
                <circle
                  ref="level3"
                  cx="79.5"
                  cy="79.5"
                  r="47.4"
                  fill={
                    this.props.alertLevel === 3 ? "#f56f3f" : "#000"
                  }
                  stroke="#e0e0e0"
                />
                <circle
                  ref="level2"
                  cx="79.5"
                  cy="79.5"
                  r="31.6"
                  fill={
                    this.props.alertLevel === 2 ? "#feb743" : "#000"
                  }
                  stroke="#e0e0e0"
                  stroke-miterlimit="10"
                />
                <circle
                  ref="level1"
                  cx="79.5"
                  cy="79.5"
                  r="18.07"
                  fill={
                    this.props.alertLevel === 1 ? "#18ee97" : "#000"
                  }
                  stroke="#e0e0e0"
                  stroke-miterlimit="10"
                />
              </g>
            </svg>
          </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/common/customRadialChart.Component.js